import { Pipe, PipeTransform } from '@angular/core';
import { RateTimeBlock } from 'src/app/pages/agreements/constants/agreement-rate-time-block.constants';
import { getTimeBlockName } from 'src/app/pages/agreements/utilities/time-block-helper';
import { TimeBlock } from 'src/app/shared/graphql/graphql-types';

@Pipe({
  name: 'timeblockName',
  standalone: true,
})
export class TimeblockNamePipe implements PipeTransform {
  transform(value: TimeBlock): RateTimeBlock['name'] {
    return getTimeBlockName(value);
  }
}
